import React from "react";
import { Select } from "@rmwc/select";
import { TextField } from "@rmwc/textfield";

const ProductStatusNew = [
	{ value: "in_stock", label: "In Stock" },
	{ value: "out_of_stock", label: "Out of Stock" }
];

const InventorySettings = ({ params, const_var, validate, changeProductStatus, changeBuildingOnCenter, openAddGableLeanBuildingModal }) => {
	const distanceValue =
		params.oncenter_val && params.oncenter_val != undefined && params.oncenter_val != 0
			? parseInt(params.oncenter_val)
			: const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t] != undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined
				? const_var.DistanceArr[params.p_b_t][params.p_r_s]
				: 2;

	const showRegenerate = params.oncenter_val != "" && (params.oncenter_val_with_action == "" || params.oncenter_val_with_action != params.oncenter_val);

	return (
		<>
			{const_var.crmSetting.is_module_name == "inventory" ? (
				<div className="form-group">
					<label className="control-label">Inventory Status</label>

					<div className="floating-label-input">
						<Select
							onChange={(e) => changeProductStatus(e.target.value)}
							value={params.display_product_status}
							className="cpanelselect"
							key={params.display_product_status}
							ripple="RipplePropF"
							rootprops="testing"
							options={ProductStatusNew}
						/>
					</div>
				</div>
			) : null}

			<div className={const_var.loginSession == true ? "row  mt-4 align-items-center d-none" : "row  mt-4 align-items-center d-none"}>
				<div className="col-8">
					<div className="floating-label-input">
						<TextField
							label="Distance on Center"
							className=""
							name="distanec_on_center"
							maxLength={50}
							onKeyUp={(e) => validate.numericCheckwithExactVal(e)}
							value={distanceValue}
							onChange={(e) => changeBuildingOnCenter(e.target.value, "input")}
						/>
					</div>
				</div>

				<div className={showRegenerate ? "col-4" : "col-4 d-none"}>
					<a className="anchor-primary f-13 roboto-medium d-inline-flex align-items-center" onClick={() => changeBuildingOnCenter(params.oncenter_val, "action")}>
						<span className="icon icon-regenerate mr-1 f-18"></span>

						<span
							className="text"
							style={{
								textDecoration: "underline"
							}}
						>
							Regenerate
						</span>
					</a>
				</div>

				<div className="col-12">
					<span className="f-12 roboto-medium text-primary">
						* You can add value between 2 to 10
						<span className="additional-info ml-1">(Only Visual)</span>
					</span>
				</div>
			</div>

			<button className="d-none btn btn-primary" onClick={openAddGableLeanBuildingModal} style={{ marginBottom: 16 }}>
				Add Side Building
			</button>
		</>
	);
};

export default InventorySettings;
